import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

let initialized = false;

function ensureInit() {
  if (initialized) return;
  dayjs.extend(relativeTime);
  dayjs.locale(
    'en-shorthand',
    {
      ...dayjs.Ls['en'],
      relativeTime: {
        future: '%s',
        past: '%s',
        s: '%ds',
        m: '1m',
        mm: '%dm',
        h: '1h',
        hh: '%dh',
        d: '1d',
        dd: '%dd',
        M: '1mo',
        MM: '%dmo',
        y: '1y',
        yy: '%dy',
      },
    },
    true,
  );
  initialized = true;
}

export function formatRelativeShort(ts: number | undefined | null): string {
  if (ts == null || isNaN(ts as number)) return '';
  ensureInit();
  const moment = dayjs(ts);
  const value = moment.locale('en-shorthand').fromNow();
  return moment.isAfter(dayjs()) ? `in ${value}` : `${value} ago`;
}
